import { createTheme } from "@material-ui/core";

const mainDrawerWidth = 240,
  mainAppBarHeight = 50,
  secondaryAppBarHeight = 50,
  recordHeaderTop = mainAppBarHeight + secondaryAppBarHeight,
  recordHeaderHeight = 115,
  PRIMARY_MAIN_COLOR = "#f0ac24";

export const theme = createTheme({
  breakpoints: {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1100,
    xl: 1920,
  },
},
  layoutDimensions: {
    mainDrawerWidth,
    mainAppBarHeight,
    secondaryAppBarHeight,
    recordHeaderTop,
    recordHeaderHeight,
  },
  contentOffsets: {
    AFTER_MAIN_APPBAR: mainAppBarHeight,
    AFTER_SECONDARY_APPBAR: secondaryAppBarHeight,
    AFTER_RECORD_HEADER: secondaryAppBarHeight + recordHeaderHeight,
  },
  mixins: {
    toolbar: {
      minHeight: 50,
    },
  },
  palette: {
    primary: {
      // colours taken directly from old portal
      // light: "#7f5500",
      main: "#293445",
      // dark: "#ffdf9e",
      contrastText: "#fff",
    },
    secondary: {
      light: "#535d70",
      main: "#293445",
      dark: "#000d1e",
      contrastText: "#fff",
    },
  },
  list: {
    itemPrimary: {
      borderLeft: `5px solid ${PRIMARY_MAIN_COLOR}`,
    },
    itemDisabled: {
      background: "#eee",
      borderLeft: "5px solid #bdbdbd",
    },
  },
  typography: {
    h1: {
      fontSize: "1.25rem",
    },
    h6: {
      color: "#293445",
      fontSize: "1em",
      marginBottom: "30px",
      marginTop: "30px",
      fontWeight: 600,
      position: "relative",
    },
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: PRIMARY_MAIN_COLOR,
        color: "#000"
      },
    },
    MuiChip: {
      deleteIconColorPrimary: {
        color: "#fff",
        "&:hover": {
          color: "#ccc",
        },
      },
      deletableColorPrimary: {
        backgroundColor: "#293445",
        color: "#fff",
        "&:focus": {
          backgroundColor: "#293445",
          color: "#fff",
        },
      },
      colorPrimary: {
        backgroundColor: "#293445",
        color: "#fff",
        "&:focus": {
          backgroundColor: "#293445",
          color: "#fff",
        },
      },
    },
    MuiInputLabel: {

      outlined: {
        
        // color: "#293445",
        fontWeight: 100,
        '&$shrink': {
          color: "#293445",
          fontWeight: 600,
        }
      },

    },
    MuiLink: {
      button: {
        backgroundColor: "#293445",
        color: "#fff",
        borderRadius: "3px",
        lineHeight: "1.75",
        fontWeight: 600,
        fontSize: "0.75rem",
        textTransform: "none",
        letterSpacing: "0.02857em",
        padding: "3px 8px",
        boxShadow: "0px 0px 10px -2px rgb(87 87 87)",

        "&:hover": {
          backgroundColor: "#293445",
          textDecoration: "underline",
        },
      },
    },
    MuiButton: {
      // disabled: {
      //   color: "#fff!important",
      // },
      textPrimary: {
        backgroundColor: "#293445",
        color: "#fff",
        borderRadius: "3px",
        lineHeight: "1.75",
        fontWeight: 600,
        fontSize: "0.75rem",
        textTransform: "none",
        letterSpacing: "0.02857em",
        padding: "3px 8px",
        boxShadow: "0px 0px 4px -2px rgb(87 87 87)",
        "&$disabled": {
          color: "#fff!important",
          marginLeft: 15,
          opacity: 0.5
        },
        "&:hover": {
          backgroundColor: "#293445",
          textDecoration: "underline",
        },
      },
    },
  },
});
